const zh = {
  // 导航
  "nav.home": "首页",
  "nav.categories": "分类浏览",
  "nav.articles": "最新资讯",
  "nav.about": "关于我们",
  "nav.register": "立即注册",

  // 首页 Hero
  "hero.title": "必赢国际·官方平台入口",
  "hero.subtitle": "备受信赖的国际化综合平台",
  "hero.description": "提供安全、公正、多元的优质服务体验，感受顶级国际平台带来的全方位保障与无限可能",
  "hero.cta_register": "立即注册",
  "hero.cta_learn": "了解更多",

  // 核心优势
  "advantages.title": "核心优势",
  "advantages.subtitle": "选择必赢国际的六大理由",
  "advantages.security.title": "安全保障",
  "advantages.security.desc": "国际顶级加密技术，多重风控体系，全面保障用户信息安全与资金安全",
  "advantages.fairness.title": "公正透明",
  "advantages.fairness.desc": "国际权威机构认证，所有服务流程公开透明，确保公平公正的游戏环境",
  "advantages.diversity.title": "多元服务",
  "advantages.diversity.desc": "涵盖多品类优质服务，满足不同用户的个性化需求，持续创新升级体验",
  "advantages.service.title": "专属客服",
  "advantages.service.desc": "7×24小时多语言客服团队，快速响应每一位会员的需求，用心服务每一天",
  "advantages.speed.title": "极速体验",
  "advantages.speed.desc": "全球服务器部署，毫秒级响应速度，畅享流畅无卡顿的极致操作体验",
  "advantages.bonus.title": "丰厚福利",
  "advantages.bonus.desc": "新会员专享礼包、定期回馈活动、VIP专属权益，让每一份投入都物超所值",

  // 会员权益
  "membership.title": "会员权益",
  "membership.subtitle": "加入必赢国际，享受尊贵会员体验",
  "membership.bronze": "青铜会员",
  "membership.silver": "白银会员",
  "membership.gold": "黄金会员",
  "membership.platinum": "铂金会员",
  "membership.diamond": "钻石会员",

  // 优惠活动
  "promotions.title": "优惠活动",
  "promotions.subtitle": "限时福利，精彩不容错过",
  "promotions.view_all": "查看全部活动",

  // 分类页
  "category.platform": "平台介绍",
  "category.membership": "会员权益",
  "category.promotions": "优惠活动",
  "category.security": "安全保障",
  "category.all": "全部分类",

  // 文章
  "article.read_more": "阅读全文",
  "article.related": "相关文章",
  "article.back": "返回列表",

  // 关于我们
  "about.title": "关于必赢国际",
  "about.brand": "品牌介绍",
  "about.reputation": "信誉保障",
  "about.contact": "联系我们",

  // 通用
  "common.loading": "加载中...",
  "common.error": "加载失败，请重试",
  "common.retry": "重试",
  "common.no_data": "暂无数据",
  "common.scroll_top": "回到顶部",
  "common.breadcrumb_home": "首页",

  // Footer
  "footer.copyright": "© 2026 必赢国际 版权所有",
  "footer.terms": "服务条款",
  "footer.privacy": "隐私政策",
  "footer.disclaimer": "免责声明",
};

export default zh;